import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Customer } from '../types';
import { customerAPI } from '../services/api';

const CustomerList: React.FC = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await customerAPI.getAll();
      setCustomers(response.data.results);
      setError(null);
    } catch (err) {
      setError('Failed to fetch companies');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this company?')) {
      try {
        await customerAPI.delete(id);
        fetchCustomers();
      } catch (err) {
        setError('Failed to delete company');
        console.error(err);
      }
    }
  };

  if (loading) return <div className="loading">Loading companies...</div>;

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>Companies</h2>
          <Link to="/customers/new" className="btn btn-primary">
            Add New Company
          </Link>
        </div>
        
        {error && <div className="error">{error}</div>}
        
        {customers.length === 0 ? (
          <p>No companies found. Add your first company to get started.</p>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((customer) => (
                  <tr key={customer.id}>
                    <td>{customer.name}</td>
                    <td>{customer.email}</td>
                    <td>{customer.phone}</td>
                    <td>{customer.city}</td>
                    <td>{customer.state}</td>
                    <td>{customer.zip_code}</td>
                    <td className="actions">
                      <Link
                        to={`/customers/${customer.id}/edit`}
                        className="btn btn-secondary btn-small"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(customer.id!)}
                        className="btn btn-danger btn-small"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerList;
